import _ from "lodash";
import * as React from "react";
import { monthSlugs } from "../../services/centralStore";
import { getSeason } from "../../services/getSeason";
import { WeatherSearchResultRowComplete } from "../../services/weatherSearch";
import { InfoSectionForMap } from "../../components/shared/card/info-section-for-map";

export const MonthIndexChart = ({
    monthIndexes,
    className
}: {
    monthIndexes: number[];
    className?: string;
}) => {
    const { labels, styles } = monthSeasons(monthIndexes);
    return (
        <>
            <div className={`relative mt-[6px] mb-[2px] h-[10px] ${className}`}>
                <div className="absolute left-0 right-0 h-full w-full rounded-md bg-gray-300 opacity-80" />
                {styles.map((st) => (
                    <div style={st} className={`absolute h-full bg-lime-700`} />
                ))}
                {_.range(1, 12).map((n) => {
                    return (
                        <div
                            key={n}
                            style={{ left: ((n / 12) * 100).toFixed(3) + "%" }}
                            className={`absolute h-full w-[2px] bg-gray-200`}
                        />
                    );
                })}
            </div>

            <div className={`text-center ${className}`}>{labels}</div>
        </>
    );
};

const monthSeasons = (monthIndexes: number[]) => {
    let lastIdx = null;
    let seasons = [];
    let currentSeason = null;
    for (let idx of monthIndexes) {
        if (!currentSeason) {
            currentSeason = [idx];
            seasons.push(currentSeason);
            lastIdx = idx;
            continue;
        }
        if (idx == lastIdx + 1) {
            currentSeason.push(idx);
        } else {
            currentSeason = null;
        }
        lastIdx = idx;
    }
    seasons = seasons.map((idxs) => [idxs[0], idxs[idxs.length - 1]]);
    const styles = [];
    for (let season of seasons) {
        let seasonLength = season[1] - season[0] + 1;
        styles.push({
            width: `${(seasonLength * 100) / 12}%`,
            left: `${(season[0] * 100) / 12}%`
        });
    }
    if (seasons[0][0] == 0 && seasons[seasons.length - 1][1] == 11) {
        seasons = [
            ...seasons.slice(1, -1),
            [seasons[seasons.length - 1][0], seasons[0][1]]
        ];
    }

    if (seasons.length > 2) {
        return { styles, labels: "" };
    }
    const labels = [];
    for (let season of seasons) {
        if (season[0] == season[1]) {
            labels.push(capitalize(monthSlugs[season[0]].slice(0, 3)));
        } else {
            let label = capitalize(monthSlugs[season[0]].slice(0, 3));
            label += "-" + capitalize(monthSlugs[season[1]].slice(0, 3));
            labels.push(label);
        }
    }
    return { styles, labels: labels.join(", ") };
};

const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};
